import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=c2c222d2"
import script from "./base-dialog.vue?vue&type=script&lang=js"
export * from "./base-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports